import { useSelector } from 'react-redux'
import { operationSlice } from '../app/reducers/operation'
import { getUrlAssets } from '../constants'
import { useTranslation } from '../hooks/useTranslation'

export default function PaymentMethodSidebar({ methodsList, methodId, chooseMethod, resolution, collapsed, setCollapsed }) {
    const operation = useSelector(operationSlice.selectSlice);
    const { t } = useTranslation();
    return (
        <div className={"payment-choose-sidebar"}>
            <div className={"payment-choose-sidebar-title"}>{t('payment.select_method')}</div>
            {methodsList.map((method, pos) => (
                <div key={method.id}
                    className={"payment-choose-btn choose-btn-" + (pos + 1) + (method.id === methodId ? " selected" : "")}
                    role="button" tabIndex={0}
                    onClick={() => chooseMethod(method, operation)}
                    onKeyDown={(e)=>{if(e.key==='Enter')chooseMethod(method, operation)}}>
                    <img src={method.small_icon} className={"sm-nav-payment-method-icon"} />
                    <span className={"lbl-payment-method-name"}>{'i18nKey' in method ? t(method.i18nKey) : method.name}</span>
                </div>
            ))}
            {resolution === "xs" && (
                <div className={"payment-choose-btn choose-btn-" + (1 + methodsList.length)} role="button" tabIndex={0} onClick={() => { setCollapsed(!collapsed) }} onKeyDown={(e)=>{if(e.key==='Enter')setCollapsed(!collapsed)}}>
                    <img src={getUrlAssets() + (collapsed ? "/sandwich.png" : "/close.png")}
                        className={"sm-nav-payment-method-icon"} />
                </div>
            )}
        </div>
    )
}
